const setDataMutation = (state, { key, val }) => {
    state.userInput[key] = val;
};

const setTotalMutation = (state, payload) => {
    state.total = payload;
};

const setRateMutation = (state, payload) => {
    state.rate = payload;
};

const setUpdateCountMutation = (state) => {
    state.updateCount += 1;
};

const setSecondYearTotalMutation = (state, payload) => {
    state.secondYearTotal = payload;
};

const setSecondYearRateMutation = (state, payload) => {
    state.secondYearRate = payload;
};

export {
    setDataMutation,
    setTotalMutation,
    setRateMutation,
    setSecondYearTotalMutation,
    setSecondYearRateMutation,
    setUpdateCountMutation,
};
